function createMangoLimiter(variantIds, limit, fetchFn) {
  var LIMIT = limit || 2;
  var ids = variantIds instanceof Set ? variantIds : new Set((variantIds || []).map(Number));
  var _fetch = fetchFn || fetch;

  function getMangoCartQty() {
    return _fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        return cart.items
          .filter(function (item) { return ids.has(item.variant_id); })
          .reduce(function (sum, item) { return sum + item.quantity; }, 0);
      });
  }

  function applyMangoLimit() {
    return getMangoCartQty().then(function (mangoQty) {
      var remaining = Math.max(0, LIMIT - mangoQty);

      // ── ATC buttons (collection page, product page) ──────────────────────
      document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(function (form) {
        var variantInput = form.querySelector('input.product-variant-id');
        if (!variantInput) return;
        if (!ids.has(parseInt(variantInput.value, 10))) return;

        var btn = form.querySelector('button[name="add"]');
        if (!btn) return;

        var wasWeDisabled = btn.hasAttribute('data-mango-disabled');
        if (btn.disabled && !wasWeDisabled) return; // Shopify sold-out — don't touch

        if (remaining === 0) {
          if (!wasWeDisabled) {
            var textEl = btn.querySelector('.btn__text');
            btn.setAttribute('data-mango-disabled', textEl ? textEl.textContent.trim() : '');
          }
          btn.disabled = true;
          var textEl = btn.querySelector('.btn__text');
          if (textEl) textEl.textContent = 'Sold Out';
        } else {
          if (wasWeDisabled) {
            btn.disabled = false;
            var textEl = btn.querySelector('.btn__text');
            var original = btn.getAttribute('data-mango-disabled');
            if (textEl && original) textEl.textContent = original;
            btn.removeAttribute('data-mango-disabled');
          }
          var qtyInput = form.querySelector('input.quantity__input');
          if (qtyInput) {
            qtyInput.setAttribute('max', remaining);
            qtyInput.setAttribute('data-max', remaining);
            if (parseInt(qtyInput.value, 10) > remaining) qtyInput.value = remaining;
          }
        }
      });

      // ── Cart quantity + buttons (cart page + cart drawer) ─────────────────
      document.querySelectorAll('input.quantity__input[data-quantity-variant-id]').forEach(function (qtyInput) {
        var variantId = parseInt(qtyInput.getAttribute('data-quantity-variant-id'), 10);
        if (!ids.has(variantId)) return;

        var container = qtyInput.closest('quantity-input') || qtyInput.parentElement;
        var plusBtn = container ? container.querySelector('button[name="plus"]') : null;
        if (!plusBtn) return;

        var wasWeDisabled = plusBtn.hasAttribute('data-mango-plus-disabled');
        if (plusBtn.disabled && !wasWeDisabled) return; // already disabled by Shopify

        if (remaining === 0) {
          plusBtn.setAttribute('data-mango-plus-disabled', 'true');
          plusBtn.disabled = true;
        } else {
          if (wasWeDisabled) {
            plusBtn.removeAttribute('data-mango-plus-disabled');
            plusBtn.disabled = false;
          }
        }
      });
    });
  }

  return { getMangoCartQty: getMangoCartQty, applyMangoLimit: applyMangoLimit };
}

// Browser init
if (typeof window !== 'undefined' && typeof module === 'undefined') {
  (function () {
    var ids = new Set((window.SpvMangoVariantIds || []).map(Number));
    if (ids.size === 0) return;
    var limiter = createMangoLimiter(ids, 2);
    document.addEventListener('DOMContentLoaded', limiter.applyMangoLimit);
    document.addEventListener('cart:updated', limiter.applyMangoLimit);
    document.addEventListener('page:loaded', limiter.applyMangoLimit);
  })();
}

if (typeof module !== 'undefined') {
  module.exports = { createMangoLimiter: createMangoLimiter };
}
